import {
  MdOutlineVerifiedUser,
} from "react-icons/md";

import Header from "../Components/Header";
import Layout from "../Components/Layout";
import { Col, Row } from "antd";
import MotifIcon from "../Assets/images/line.svg";
import InfoBox from "../Components/InfoBox";


function View() {

  return (
    <Layout>
      <Row justify="center">
        <Col xs={24} md={16} lg={12}>
        <div className="done__wrapper">
          <Header
            title="Souscription réussie !"
            highlight="Souscription réussie !"
            short="Votre souscription a été effectuée avec succès. Tous les documents vous ont été transférés par e-mail."
            icon={<MdOutlineVerifiedUser size={64} />}
          />


          <img src={MotifIcon} alt="" className="done__wrapper--icon" />

          <h4 className="done__wrapper--title">
            <strong>Amellis Mutuelles</strong>{" "}
             vous remercie pour votre confiance.
          </h4>

          <InfoBox text="Vous recevrez d'ici quelques jours un SMS de bienvenue vous invitant à créer votre espace en ligne pour vous permettre de télécharger votre carte mutuelle." />
          </div>
        </Col>
      </Row>


    </Layout>
  );
}

export default View;
